export const languages = { en: 'en', id: 'id' };
